import { DefaultMainHeaderMenu, MainHeaderMenu, MenuStates } from '../../models';

export function createEmptyMenu(state: MenuStates, title: string): MainHeaderMenu {
    return new DefaultMainHeaderMenu(state, {
        title,
        items: [],
        showSearch: false
    });
}
